import { useMemo, useState } from 'react';
import Fuse from 'fuse.js';
import { BlogPost } from '../../types/blog';

interface UseBlogSearchResult {
  query: string;
  setQuery: (query: string) => void;
  results: BlogPost[];
}

export function useBlogSearch(posts: BlogPost[]): UseBlogSearchResult {
  const [query, setQuery] = useState('');

  const fuse = useMemo(
    () =>
      new Fuse(posts, {
        keys: [
          { name: 'title', weight: 0.4 },
          { name: 'description', weight: 0.3 },
          { name: 'tags', weight: 0.2 },
          { name: 'content', weight: 0.1 },
        ],
        threshold: 0.3,
        includeScore: true,
        ignoreLocation: true,
      }),
    [posts]
  );

  const results = useMemo(() => {
    if (!query.trim()) return posts;
    return fuse.search(query).map((r) => r.item);
  }, [query, fuse, posts]);

  return { query, setQuery, results };
}

export default useBlogSearch;
